<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات سوال"
        >
          <b-form @submit.prevent>
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="12">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="دسته بندی"
                      label-for="FaqCategoryId"
                    >
                        <z-faq-category
                            v-model="Form.FaqCategoryId"
                            :multiple="false"
                        />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="ترتیب"
                      label-for="Sort"
                    >
                      <b-form-input
                        id="Sort"
                        v-model="Form.Sort"
                        name="Sort"
                        type="number"
                        autocomplete="off"
                      />
                    </b-form-group>

                  </b-col>

                  <b-col cols="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-textarea
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          rows="8"
                        />
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group
                        :label="$t('foods.tags')"
                        label-for="Tags"
                    >
                      <b-form-tags
                          v-model="Form.Tags"
                          name="Tags"
                          input-id="Tags"
                          placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZFaqCategory from "@/tools/faqcategory"
import DynamicSelect from  '@/tools/dynamicSelect.vue'

export default {
  name: 'FaqDetails',
  components: {
    ZFaqCategory,
    DynamicSelect
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Description: null,
        Sort: 0,
        FaqCategoryId: null,
        Tags: []
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.faq.add
      if (this.$route.params.id) {
        url = this.$api.faq.update
      }

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        }).finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.faq.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = {
            ...res.data,
            Tags: res.data.Tag
          }
          delete this.Form.Tag
        })
    },
  },
}
</script>
